import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import Checkbox from '@gik/ui/Checkbox';
import noop from '@gik/core/utils/noop';

export interface IWeekdaySelectorProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  value?: boolean[];
  inline?: boolean;
  onChange?(value: boolean[]): void;
  onInit?(value: boolean[]): void;
}

export default function WeekdaySelector({
  value = [],
  inline,
  className,
  onChange = noop,
  onInit = noop,
  ...otherProps
}: IWeekdaySelectorProps): React.ReactElement {
  const options = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

  const bem = bemBlock('weekday-selector');

  React.useEffect(() => {
    const newSelection = [];
    options.map((_option, i) => {
      newSelection[i] = value && value[i] ? value[i] : false;
    });
    onInit(newSelection);
  }, []);

  function handleChange(index: number, newValue: boolean) {
    const newSelection = value ? value.concat([]) : [];
    newSelection[index] = newValue;
    options.forEach((_option, i) => {
      // make sure we have a value for all options
      // and make sure there are no null values
      newSelection[i] = newSelection[i] || false;
    });
    onChange(newSelection);
  }

  return (
    <div className={bem(null, [{ inline }], className)} {...otherProps}>
      {options.map((_option, i) => {
        const checked = value ? value[i] : false;
        return <Checkbox checked={checked} key={i} icon={_option} onValueChange={value => handleChange(i, value)} />;
      })}
    </div>
  );
}
